import { Chat } from '@repo/db'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { ComponentOrderMessageVO } from '@repo/types/src/types/ComponentOrderMessageVO'

export const useSendOrderMessageForm = (chat: Chat, userId?: string) => {
  const schema = z
    .object({
      connectionKey: z.string().min(1),
      phoneNumber: z.string().min(1),
      text: z.string().min(1).max(65356),
      type: z.enum(['pix_dynamic_code', 'payment_link', 'boleto']),
      value: z.string().min(1).max(512),
      items: z.array(
        z.object({
          name: z.string().min(1).max(255),
          quantity: z.number().min(1),
          price: z.string().min(1)
        })
      ),
      userId: z.string().min(1)
    })
    .superRefine((data, ctx) => {
      const { type, value } = data

      if (type === 'boleto') {
        if (!(value.length === 53 || value.length === 52)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['value']
          })
        }
      }
    })

  const form = useForm<ComponentOrderMessageVO>({
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    defaultValues: {
      connectionKey: chat.connectionKey,
      phoneNumber: chat.phoneNumber,
      items: [
        {
          name: '',
          quantity: 1,
          price: undefined
        }
      ],
      text: '',
      value: '',
      type: 'pix_dynamic_code',
      userId: userId ?? chat.userId
    }
  })

  return { form }
}
